import { c as _c } from "react/compiler-runtime";
import { Bell, CheckCheck } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@osmix/ui/badge";
import { Button } from "@osmix/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@osmix/ui/card";
import { useNotificationReadActions, useNotifications } from "@/api/hooks/use-notifications";
export function NotificationsPage() {
  const $ = _c(72);
  const {
    t
  } = useTranslation();
  const [filter, setFilter] = useState("all");
  const query = useNotifications(filter);
  const actions = useNotificationReadActions();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== actions.markAll || $[1] !== actions.markRead || $[2] !== filter || $[3] !== query.data?.pages || $[4] !== query.error || $[5] !== query.isPending || $[6] !== t) {
    const items = query.data?.pages.flatMap(_temp) ?? [];
    t0 = "mx-auto grid max-w-4xl gap-4";
    let t7;
    if ($[14] !== t) {
      t7 = t("notifications.title");
      $[14] = t;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t7) {
      t8 = <h1 className="text-2xl font-bold">{t7}</h1>;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== t) {
      t9 = t("notifications.description");
      $[18] = t;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t9) {
      t10 = <p className="text-sm text-muted-foreground">{t9}</p>;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
      t11 = <div>{t8}{t10}</div>;
      $[22] = t10;
      $[23] = t8;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    let t12;
    if ($[25] !== actions.markAll) {
      t12 = () => actions.markAll.mutate();
      $[25] = actions.markAll;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    const t13 = actions.markAll.isPending || items.length === 0;
    let t14;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <CheckCheck className="size-4" />;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    let t15;
    if ($[28] !== t) {
      t15 = t("notifications.markAllRead");
      $[28] = t;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    let t16;
    if ($[30] !== t12 || $[31] !== t13 || $[32] !== t15) {
      t16 = <Button variant="outline" onClick={t12} disabled={t13}>{t14} {t15}</Button>;
      $[30] = t12;
      $[31] = t13;
      $[32] = t15;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    if ($[34] !== t11 || $[35] !== t16) {
      t1 = <div className="flex flex-wrap items-center justify-between gap-3">{t11}{t16}</div>;
      $[34] = t11;
      $[35] = t16;
      $[36] = t1;
    } else {
      t1 = $[36];
    }
    const t17 = filter === "all" ? "default" : "outline";
    let t18;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = () => setFilter("all");
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    let t19;
    if ($[38] !== t) {
      t19 = t("notifications.all");
      $[38] = t;
      $[39] = t19;
    } else {
      t19 = $[39];
    }
    let t20;
    if ($[40] !== t17 || $[41] !== t19) {
      t20 = <Button size="sm" variant={t17} onClick={t18}>{t19}</Button>;
      $[40] = t17;
      $[41] = t19;
      $[42] = t20;
    } else {
      t20 = $[42];
    }
    const t21 = filter === "unread" ? "default" : "outline";
    let t22;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = () => setFilter("unread");
      $[43] = t22;
    } else {
      t22 = $[43];
    }
    let t23;
    if ($[44] !== t) {
      t23 = t("notifications.unread");
      $[44] = t;
      $[45] = t23;
    } else {
      t23 = $[45];
    }
    let t24;
    if ($[46] !== t21 || $[47] !== t23) {
      t24 = <Button size="sm" variant={t21} onClick={t22}>{t23}</Button>;
      $[46] = t21;
      $[47] = t23;
      $[48] = t24;
    } else {
      t24 = $[48];
    }
    if ($[49] !== t20 || $[50] !== t24) {
      t2 = <div className="flex gap-2">{t20}{t24}</div>;
      $[49] = t20;
      $[50] = t24;
      $[51] = t2;
    } else {
      t2 = $[51];
    }
    if ($[52] !== query.isPending || $[53] !== t) {
      t3 = query.isPending && <p className="text-muted-foreground">{t("notifications.loading")}</p>;
      $[52] = query.isPending;
      $[53] = t;
      $[54] = t3;
    } else {
      t3 = $[54];
    }
    if ($[55] !== query.error) {
      t4 = query.error && <div className="rounded-md border border-destructive/40 p-4 text-destructive">{query.error.message}</div>;
      $[55] = query.error;
      $[56] = t4;
    } else {
      t4 = $[56];
    }
    t5 = !query.isPending && !query.error && items.length === 0 && <Card><CardContent className="flex flex-col items-center gap-2 py-12 text-center text-muted-foreground"><Bell className="size-8" /><p>{t(filter === "unread" ? "notifications.emptyUnread" : "notifications.empty")}</p></CardContent></Card>;
    let t25;
    if ($[57] !== actions.markRead || $[58] !== t) {
      t25 = item => <Card key={item.id} className={!item.readAt ? "border-primary/40 bg-primary/5" : undefined}><CardHeader className="pb-2"><div className="flex items-start justify-between gap-3"><CardTitle className="text-base">{item.title}</CardTitle>{!item.readAt && <Badge>{t("notifications.new")}</Badge>}</div></CardHeader><CardContent className="grid gap-3"><p className="whitespace-pre-wrap text-sm">{item.body}</p><div className="flex items-center justify-between gap-2 text-xs text-muted-foreground"><time dateTime={item.createdAt}>{new Date(item.createdAt).toLocaleString()}</time>{!item.readAt && <Button size="sm" variant="ghost" onClick={() => actions.markRead.mutate(item.id)}>{t("notifications.markRead")}</Button>}</div></CardContent></Card>;
      $[57] = actions.markRead;
      $[58] = t;
      $[59] = t25;
    } else {
      t25 = $[59];
    }
    t6 = items.map(t25);
    $[0] = actions.markAll;
    $[1] = actions.markRead;
    $[2] = filter;
    $[3] = query.data?.pages;
    $[4] = query.error;
    $[5] = query.isPending;
    $[6] = t;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t0 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[60] !== query || $[61] !== t) {
    t7 = query.hasNextPage && <Button variant="outline" className="mx-auto" disabled={query.isFetchingNextPage} onClick={() => void query.fetchNextPage()}>{query.isFetchingNextPage ? t("notifications.loading") : t("notifications.loadMore")}</Button>;
    $[60] = query;
    $[61] = t;
    $[62] = t7;
  } else {
    t7 = $[62];
  }
  let t8;
  if ($[63] !== t0 || $[64] !== t1 || $[65] !== t2 || $[66] !== t3 || $[67] !== t4 || $[68] !== t5 || $[69] !== t6 || $[70] !== t7) {
    t8 = <div className={t0}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[63] = t0;
    $[64] = t1;
    $[65] = t2;
    $[66] = t3;
    $[67] = t4;
    $[68] = t5;
    $[69] = t6;
    $[70] = t7;
    $[71] = t8;
  } else {
    t8 = $[71];
  }
  return t8;
}
function _temp(page) {
  return page.items;
}